import ProductPage from 'ai/components/EntryPoint/ProductPage/ProductPage';
import { withProductPageProps } from 'ai/viewModel/entryPoint/withProductPageProps';

export default withProductPageProps(ProductPage);
